import { BehaviorContext } from '../../behavior-context';

export const ANALYTICS_KEYS = {
  EVENT_TRACKER: 'eventTracker',
  VIRTUAL_PAGEVIEW: 'virtualPageview',
  APPLICATION_ENGAGEMENT: 'Application Engagement',
  APPLICATION_START: 'Application Start',
  APPLICATION_RESUME: 'Application Resume',
  APPLICATION_SUBMISSION: 'Application Submission',
  APPLICATION_EXIT: 'Application Exit',
  PAYMENT_ESTIMATOR: 'Payment Estimator',
  ERRORS: 'Errors',
  VALUE_PROP_SCREEN: 'Value Prop Screen',
  OTP: 'OTP',
};

/**
 * Returns the amount of time elapsed between the start end date timestamps, formatted as HH:MM:SS.mmm
 * If startDate is later than endDate, returns 00:00:00.000 (cannot have negative elapsed time)
 */
export function getElapsedTime(startDate: Date, endDate: Date): string {
  let milis = endDate.getTime() - startDate.getTime();
  if (milis <= 0) {
    return '00:00:00.000';
  }

  milis = milis / 1000;
  const elapsedHours = Math.floor(milis / 3600);
  milis = milis - elapsedHours * 3600;
  const elapsedMins = Math.floor(milis / 60);
  milis = milis - elapsedMins * 60;
  const elapsedSecs = milis;

  let hrs = elapsedHours.toString();
  let mins = elapsedMins.toString();
  let secs = elapsedSecs.toFixed(3).toString();

  if (elapsedHours < 10) {
    hrs = '0' + hrs;
  }
  if (elapsedMins < 10) {
    mins = '0' + mins;
  }
  if (elapsedSecs < 10) {
    secs = '0' + secs;
  }

  return hrs + ':' + mins + ':' + secs;
}

export function pushToDataLayer(data) {
  const anyWindow: any = window;
  if (anyWindow.dataLayer) {
    anyWindow.dataLayer.push(data);
  }
}

export function pushErrorToDataLayer(errorType, errorMessage) {
  const payload = {
    event: ANALYTICS_KEYS.EVENT_TRACKER,
    eventCategory: ANALYTICS_KEYS.ERRORS,
    eventAction: errorType,
    eventLabel: errorMessage,
    eventValue: 0,
    eventNonInteraction: 0,
    errors: 1,
  };
  pushToDataLayer(payload);
}

export function readVariableFromContext(varName, ctx: BehaviorContext) {
  if (ctx.has(varName)) {
    return ctx.get(varName);
  } else if (
    ctx.formGroup &&
    ctx.formGroup.value &&
    ctx.formGroup.value[varName]
  ) {
    return ctx.formGroup.value[varName];
  }
}
